import * as Yup from "yup";
import { InputProps } from "./Form.Interface"
import Forms from "./Form.Object";

type YupString = Yup.StringSchema<any | undefined, any | undefined>

const generateValidations = (field: InputProps) => {
    let schema = (Yup[field.typeValue ? field.typeValue : 'string'] as () => Yup.AnySchema)();
    let schemaa = (Yup[field.typeValue ? field.typeValue : 'array'] as () => Yup.AnySchema)()
    for (const rule of field.validations) {
        switch (rule.type) {
            case 'matches': schema = (schema as YupString).matches(rule?.value as RegExp, rule.message); break;
            case 'minLength': schema = (schema as YupString).min(rule?.value as number, rule.message); break;
            case 'maxLength': schema = (schema as YupString).max(rule?.value as number, rule.message); break;
            case 'isEmail': schema = (schema as YupString).email(rule.message); break;
            case 'multiSelect': schemaa = Yup.array().min(rule?.value as number, rule.message); break;
            default: schema = schema.required(rule.message); break;
        }
    }
    return schema;
}

type Form = 'region_master' |
    'hull_type_master' |
    'direction_master' |
    'beaufort_scale_master' |
    'contact_type_master' |
    'port_master' |
    'vessel_owner_master' |
    'country_master' |
    'vessel_load_condition_master' |
    'wind_direction_master' |
    'unit_group_master' |
    'unit_master' |
    'vessel_type_master' |
    'vessel_sub_type_master' |
    'fuel_type_master' |
    'fuel_master' |
    'fuel_sub_type_master' |
    'reporting_operation_mode_master' |
    'reporting_events_master' |
    'reporting_type_master' |
    'current_direction_master' |
    'machinery_list_master' |
    'vessel_machinery_list' |
    'sensor_list_master' |
    'vessel_sensors_list' |
    'lube_oil_list_master' |
    'vessel_lube_oil_list' |
    'reporting_events_list_master' |
    'vessel_reporting_events_list' |
    'douglas_sea_scale_master' |
    'vessel_owner_master' |
    'strait_canal_transit_list_master' |
    'cii_adjustment_events_master' |
    'vessel_owner_master' |
    'cargo_control_room' |
    'Ballast_information_of_vessel' |
    'vessel_coating_information' |
    'vessel_for_usa_calls' |
    'anchors_towing_system' |
    'escort_tug' |
    'mooring_wire_on_drum' |
    'mooring_wire_tail' |
    'mooring_ropes_on_drum' |
    'mooring_other_line' |
    'mooring_winche' |
    'bitts_closed_chock' |
    'cargo_pump' |
    'common_contacts' |
    'vessel_build_information' |
    'vessel_dimension' |
    'certificates' |
    'lifting_equipment_or_gangway' |
    'inert_gas_and_crude_oil_washing' |
    'fuel_category_master' |
    any

export const getInputs = (section: Form) => {
    let initialValues: { [key: string]: any } = {};
    let validationsFields: { [key: string]: any } = {};
    for (const field of Forms[section]) {
        initialValues[field.name] = field.value;
        if (!field.validations) continue;
        const schema = generateValidations(field)
        validationsFields[field.name] = schema;
    }

    return {
        validationSchema: Yup.object({ ...validationsFields }),
        initialValues,
        inputs: Forms[section],
    };

};
